import React from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

import * as selectors from 'selectors';
import * as actions from 'actions';
import * as Modules from 'components/modules';

import styles from './reels.css';

class Reels extends React.Component {
  state = { active: false };

  clickHandler = (i) => {
    if (i === this.state.active) {
      this.setState(
        {
          active: false,
        },
        this.props.showHeader,
      );
    } else {
      this.setState(
        {
          active: i,
        },
        this.props.hideHeader,
      );
    }
  };
  render() {
    const {
      reels, meta, loadCb, pageReady,
    } = this.props;
    const { active } = this.state;

    return (
      <div className={styles.root} id="worksRoot">
        <div className={styles.reels}>
          {reels &&
            reels.map((item, i) => {
              if (item.type === 'meta') {
                return <Modules.Meta key={i} {...item} />;
              }
              if (item.type !== 'reel') {
                return;
              }
              return (
                <Modules.MobileReel
                  key={item.title}
                  {...item}
                  loadCb={loadCb}
                  pageReady={pageReady}
                  clickHandler={() => this.clickHandler(i)}
                  active={i === active}
                />
              );
            })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  meta: selectors.getStaticMeta(state),
});

const mapDispatchToProps = dispatch => ({
  hideHeader: () => dispatch({ type: actions.HIDE_HEADER }),
  showHeader: () => dispatch({ type: actions.SHOW_HEADER }),
});

Reels.defaultProps = {
  meta: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(Reels);



// WEBPACK FOOTER //
// ./src/components/screens/Reels/MobileReels.js